export default __webpack_public_path__ + "static/INSTAR_MQTT-b651eb031a37d229a74515a8d63b8cbe.webp";